define('view/controller/booking/datetime/classes/TimeClassesTimeItemView',['require','view/controller/booking/datetime/slots/TimeSlotView'],function (require) {

    var TimeSlotView = require('view/controller/booking/datetime/slots/TimeSlotView');

    /**
     * Time slot item view
     *
     * @class TimeClassesTimeItemView
     */
    return TimeSlotView.extend({

        template: '#time_classes_time_item_view'

    });

});
